import { Box, Flex } from '@landsbankinn/ui-kit';
import { Logo } from '@landsbankinn/ui/esm';
import { type ReactNode } from 'react';

export function ServerError(props: { children?: ReactNode }) {
  return (
    <Flex
      mainAxisAlignment="center"
      minHeight="100vh"
      background="blue baseLight"
      padding="20"
      paddingTop="90"
    >
      <Box>
        <Box paddingBottom="70">
          <Logo color="blue" style={{ width: 44, height: 44 }} />
        </Box>
        {props.children}
      </Box>
    </Flex>
  );
}
